<template>
    <div class="product-history">
        <div class="header-container">
            <h1>商品历史记录</h1>
            <button class="btn btn-secondary" @click="goBack">返回</button>
        </div>

        <div v-if="loading" class="loading">加载中...</div>

        <div v-if="error" class="alert alert-danger">
            {{ error }}
        </div>

        <!-- 商品历史列表 -->

        <!-- 批量操作栏 -->
        <div v-if="!loading && products.length > 0" class="batch-actions">
            <div class="select-all">
                <input type="checkbox" id="selectAll" v-model="selectAll" @change="handleSelectAll">
                <label for="selectAll">全选</label>
            </div>
            <button class="btn btn-danger" @click="confirmBatchDelete" :disabled="selectedProducts.length === 0">
                批量删除 ({{ selectedProducts.length }})
            </button>
        </div>

        <table v-if="!loading && products.length > 0" class="product-table">
            <thead>
            <tr>
                <th></th>
                <th>ID</th>
                <th>名称</th>
                <th>价格</th>
                <th>库存</th>
                <th>状态</th>
                <th>创建时间</th>
                <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="product in products" :key="product.id">
                <td>
                    <input type="checkbox" :id="'product-' + product.id" v-model="selectedProducts" :value="product.id" @change="handleSelectChange">
                </td>
                <td>{{ product.id }}</td>
                <td>{{ product.name }}</td>
                <td>¥{{ product.price.toFixed(2) }}</td>
                <td>{{ product.stock }} 件</td>
                <td>
                    <span v-if="product.active" class="status-active">在售</span>
                    <span v-else class="status-inactive">已下架</span>
                    <span v-if="product.frozen" class="status-frozen"> (已冻结)</span>
                </td>
                <td>{{ formatDate(product.createdAt) }}</td>
                <td>
                    <!-- 编辑按钮 -->
                    <a :href="'/seller/dashboard/product/new?id=' + product.id" class="btn btn-edit">编辑</a>

                    <!-- 上架 / 下架 按钮 -->
                    <button
                            class="btn"
                            :class="{ 'btn-secondary': product.active, 'btn-success': !product.active }"
                            @click="toggleActive(product)"
                            :disabled="false">
                        {{ product.active ? '下架' : '上架' }}
                    </button>

                    <!-- 删除按钮 -->
                    <button
                            class="btn btn-danger"
                            @click="confirmDelete(product)"
                            :disabled="false">
                        删除
                    </button>
                </td>
            </tr>
            </tbody>
        </table>

        <div v-if="!loading && products.length === 0" class="alert alert-danger">
            暂无商品记录
        </div>
    </div>
</template>

<script>
    export default {
      name: 'ProductHistory',
      data() {
        return {
          products: [],
          loading: true,
          error: '',
          selectAll: false,
          selectedProducts: []
        }
      },
      created() {
        this.fetchProducts()
      },
      methods: {
        async fetchProducts() {
          try {
            this.loading = true
            const sellerId = localStorage.getItem('sellerId')
            if (!sellerId) {
              this.error = '请先登录'
              return
            }
            const response = await this.$axios.get(`/products/seller/${sellerId}`) // 根据商户ID获取商品
            this.products = response.data
            this.error = ''
          } catch (err) {
            this.error = '获取商品列表失败'
            console.error(err)
          } finally {
            this.loading = false
          }
        },

        // 获取当前在售商品数量
        getActiveProductsCount() {
          return this.products.filter(p => p.isActive).length
        },

        async toggleActive(product) {
          try {
            if (product.active) {
              // 当前是"在售"，执行下架
              await this.$axios.put(`/products/${product.id}/deactivate`)
              // 设置本地存储标志，指示有商品状态已变更
              localStorage.setItem('productStatusChanged', 'true')
            } else {
              // 当前是"已下架"，执行上架
              await this.$axios.put(`/products/${product.id}/activate`)
              // 设置本地存储标志，指示有商品状态已变更
              localStorage.setItem('productStatusChanged', 'true')
            }

            // 刷新商品列表
            this.fetchProducts()
          } catch (err) {
            this.error = '操作失败，请重试'
            console.error(err)
          }
        },

        formatDate(dateString) {
          if (!dateString) return ''
          const date = new Date(dateString)
          return date.toLocaleString()
        },

        // 确认删除商品
        confirmDelete(product) {
          if (confirm(`确定要删除商品"${product.name}"吗？此操作不可恢复。`)) {
            this.deleteProduct(product.id)
          }
        },

        // 删除商品
        async deleteProduct(productId) {
          try {
            console.log('开始删除商品，ID:', productId)
            const sellerId = localStorage.getItem('sellerId')
            if (!sellerId) {
              this.error = '请先登录'
              return
            }
            const response = await this.$axios.delete(`/products/${productId}/seller/${sellerId}`)
            console.log('删除商品响应:', response)
            // 设置本地存储标志，指示有商品已删除
            localStorage.setItem('productStatusChanged', 'true')
            console.log('本地存储标志已设置')
            // 刷新商品列表
            await this.fetchProducts()
            console.log('商品列表已刷新')
          } catch (err) {
            this.error = '删除商品失败，请重试'
            console.error('删除商品失败:', err)
          }
        },
        
        // 处理全选/取消全选
        handleSelectAll() {
          if (this.selectAll) {
            // 全选：将所有商品ID添加到选中列表
            this.selectedProducts = this.products.map(product => product.id)
          } else {
            // 取消全选：清空选中列表
            this.selectedProducts = []
          }
        },
        
        // 处理单个商品选择状态变化
        handleSelectChange() {
          // 检查是否所有商品都被选中
          this.selectAll = this.selectedProducts.length === this.products.length
        },
        
        // 确认批量删除
        confirmBatchDelete() {
          if (this.selectedProducts.length === 0) {
            alert('请先选择要删除的商品')
            return
          }
          
          if (confirm(`确定要删除选中的${this.selectedProducts.length}个商品吗？此操作不可恢复。`)) {
            this.batchDeleteProducts()
          }
        },
        
        // 批量删除商品
        async batchDeleteProducts() {
          try {
            const sellerId = localStorage.getItem('sellerId')
            if (!sellerId) {
              this.error = '请先登录'
              return
            }
            // 逐个删除选中的商品
            for (const productId of this.selectedProducts) {
              await this.$axios.delete(`/products/${productId}/seller/${sellerId}`)
            }
            
            // 设置本地存储标志，指示有商品已删除
            localStorage.setItem('productStatusChanged', 'true')
            
            // 清空选中列表
            this.selectedProducts = []
            this.selectAll = false
            
            // 刷新商品列表
            await this.fetchProducts()
            
            alert('批量删除成功')
          } catch (err) {
            this.error = '批量删除商品失败，请重试'
            console.error('批量删除商品失败:', err)
          }
        },
        
        // 返回上一页
        goBack() {
          this.$router.push('/seller/dashboard')
        }
      }
    }
</script>

<style scoped>
    .loading {
      text-align: center;
      padding: 2rem;
      font-size: 1.2rem;
    }

    .alert {
      padding: 1rem;
      margin: 1rem 0;
      border-radius: 4px;
    }

    .alert-danger {
      background-color: #f8d7da;
      color: #721c24;
      border: 1px solid #f5c6cb;
    }

    .product-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 1rem;
    }

    .product-table th,
    .product-table td {
      padding: 0.75rem;
      text-align: left;
      border-bottom: 1px solid #ddd;
    }

    .status-active {
      color: #28a745;
      font-weight: bold;
    }

    .status-inactive {
      color: #6c757d;
    }

    .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
    }

    .btn-secondary {
      background-color: #6c757d;
      color: white;
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      cursor: pointer;
      text-decoration: none;
    }

    .btn-secondary:hover {
      background-color: #5a6268;
    }

    .status-frozen {
      color: #dc3545;
    }

    .btn {
          margin-right: 0.75rem;
          padding: 0.25rem 0.75rem;
          color: white;
          text-decoration: none;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        /* 编辑按钮 - 蓝色 */
        .btn-edit {
          background: #1976d2;
        }

        .btn-edit:hover {
          background: #1565c0;
        }

        /* 下架按钮 - 灰色 */
        .btn-secondary {
          background: #6c757d;
        }

        /* 上架按钮 - 绿色 */
        .btn-success {
          background: #388e3c;
        }

        /* 删除按钮 - 红色（较浅） */
        .btn-danger {
          background: #e53935;
        }

        .btn-danger:hover {
          background: #d32f2f;
        }

    .btn:disabled {
            background: #ccc;
            cursor: not-allowed;
        }

        /* 批量操作栏样式 */
        .batch-actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
            padding: 0.75rem;
            background-color: #f8f9fa;
            border-radius: 4px;
            border: 1px solid #dee2e6;
        }

        .select-all {
            display: flex;
            align-items: center;
        }

        .select-all input[type="checkbox"] {
            margin-right: 0.5rem;
        }

        /* 表格中的复选框样式 */
        .product-table input[type="checkbox"] {
            margin: 0;
        }

        .product-table th:first-child,
        .product-table td:first-child {
            text-align: center;
            width: 50px;
        }
</style>
